// extracted by mini-css-extract-plugin
module.exports = {"content":"StrategyTickers_content__2AaYP","header":"StrategyTickers_header__3AkVA"};